import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modals_action/affiliate-signup/stage';
import DeviceSelector from '../../../../selectors/device'
import {isSupported, isAppStandalone} from '../../../../lib/firebase';
import App from './app';
import Notifications from './notifications';


export default ({game, close}) => {
    const {button} = useSelector(Selector),
          {device_os} = useSelector(DeviceSelector),
          notifications_supported = isSupported(),
          standalone = isAppStandalone();

    const need_pwa = device_os === "iOS" && !notifications_supported && !standalone;

    if(need_pwa)
        return <App game={game} close={close} />

    return <Notifications game={game} close={close} />
}